import { Tag, Tooltip } from 'antd';

/**
 * A single inline [n] citation marker. When it maps to a known source it becomes
 * a clickable chip that opens the source document (highlighted); otherwise it
 * renders as a plain (non-clickable) chip.
 */
function CitationRef({ num, citation, onOpen }) {
  const clickable = !!(citation && citation.documentId);

  const chip = (
    <Tag
      color={clickable ? 'blue' : 'default'}
      onClick={clickable ? () => onOpen(citation) : undefined}
      style={{
        cursor: clickable ? 'pointer' : 'default',
        marginInline: 1,
        padding: '0 6px',
        fontSize: 11,
        lineHeight: '18px',
        borderRadius: 9,
        verticalAlign: 'baseline',
      }}
    >
      {num}
    </Tag>
  );

  if (!clickable) return chip;
  return <Tooltip title={citation.title}>{chip}</Tooltip>;
}

/**
 * Renders an assistant answer, converting inline [n] citation markers into
 * clickable source chips. Plain text (including newlines) is preserved by the
 * pre-wrap container in MessageBubble.
 */
export default function MessageContent({ content, citations, onOpenSource }) {
  if (!content) return null;

  const byMarker = new Map((citations || []).map((c) => [c.marker, c]));
  const nodes = [];
  const regex = /\[(\d+)\]/g;
  let last = 0;
  let match = regex.exec(content);
  let key = 0;

  while (match !== null) {
    if (match.index > last) {
      nodes.push(content.slice(last, match.index));
    }
    const num = Number(match[1]);
    nodes.push(
      <CitationRef
        key={`c-${key}`}
        num={num}
        citation={byMarker.get(num)}
        onOpen={onOpenSource}
      />
    );
    key += 1;
    last = match.index + match[0].length;
    match = regex.exec(content);
  }
  if (last < content.length) nodes.push(content.slice(last));

  return nodes;
}
